// Test Paywall Registry
// Add imports for your test paywall JSON files here
import { NamiInitialConfig } from "@namiml/web-sdk";
import basicAnimations from './basic-animations.json';

type FullInitialConfig = Exclude<NamiInitialConfig, { initial_config: string }>;
type NamiPaywalls = FullInitialConfig['paywalls'];
type NamiPaywall = NonNullable<NamiPaywalls>[number];

export const testPaywallFiles: Record<string, NamiPaywall> = {
  'basic-animations': basicAnimations as unknown as NamiPaywall,
  // Add more test paywall imports here...
};

export default testPaywallFiles;
